"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSErrorsClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
const export_file_util_1 = require("./utils/export-file.util");
const settings_1 = require("../settings");
class JSErrorsClient extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.executor.setFormatDateWithTimezone(true);
    }
    getTopErrors(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/top-errors`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getErrorMetricsData(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/error-metrics`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getAggregatedErrorsInfo(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/aggregated-errors-info`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getCharts(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/charts`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getExportData(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/export-errors`;
            const response = yield this.executeRaw('post', url, request);
            const exportResponse = {
                buffer: response.data,
                filename: (0, export_file_util_1.getFileNameFromContentDisposition)(response.headers['content-disposition']),
                contentType: response.headers['content-type'],
            };
            return exportResponse;
        });
    }
    getErrorMetricsDataV2(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v2/projects/${projectId}/js-errors/error-metrics`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getErrorMetricsDataV2WithDismissed(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v2/projects/${projectId}/js-errors/error-metrics-with-dismissed`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getErrorMetricsDataV2WithStatuses(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v2/projects/${projectId}/js-errors/error-metrics-with-statuses`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getAggregatedErrorsInfoV2(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v2/projects/${projectId}/js-errors/aggregated-errors-info`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getChartsV2(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v2/projects/${projectId}/js-errors/charts`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    updateDismissedErrorStatus(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/errors-meta`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    updateErrorStatus(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/error-status`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
}
exports.JSErrorsClient = JSErrorsClient;
//# sourceMappingURL=js-errors.client.js.map